import { styled } from '@creditas-ui/system'

const Wrapper = styled.div`
  width: 100%;
`

export default Wrapper
